import { render, staticRenderFns } from "./MsTextArea.vue?vue&type=template&id=5dd65382&scoped=true"
import script from "./MsTextArea.vue?vue&type=script&lang=js"
export * from "./MsTextArea.vue?vue&type=script&lang=js"
import style0 from "./MsTextArea.vue?vue&type=style&index=0&id=5dd65382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd65382",
  null
  
)

export default component.exports